module.exports = __webpack_public_path__ + "img/question-thin.7a918c3b.svg";